import React from 'react';
import ReactDOM from 'react-dom/client'; // Yeni import

import App from './App';

import './index.css';

// React 18 ile gelen createRoot
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <App />
);
